import Vue from 'vue'
import Router from 'vue-router'

const lazy = (path) => () => import(`@/views/${path}.vue`)

// let isHistoryApi = !(window.history && history.pushState)

Vue.use(Router)

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: lazy('Login')
    },
    {
      path: '/home',
      name: 'Home',
      meta: {
        name: '首页'
      },
      component: lazy('Home'),
      // redirect: { name: 'health-archives' },
      children: [
        {
          path: '/home/homeindex',
          name: 'homeindex',
          meta: {
            name: '概览'
          },
          component: lazy('HomeIndex')
        },
        {
          path: '/home/usercenter',
          name: 'usercenter',
          meta: {
            name: '个人中心'
          },
          component: lazy('UserCenter')
        },
        {
          path: '/home/health-archives',
          name: 'health-archives',
          meta: {
            name: '健康档案'
          },
          component: lazy('health/HealthArchives')
        },
        {
          path: '/home/medical-record/:id',
          name: 'medical-record',
          meta: {
            name: '病历管理'
          },
          component: lazy('health/MedicalRecord')
        },
        {
          path: '/home/health-assess',
          name: 'health-assess',
          meta: {
            name: '健康评估'
          },
          component: lazy('health/HealthAssess')
        },
        {
          path: '/home/health-interfere',
          name: 'health-interfere',
          meta: {
            name: '健康干预'
          },
          component: lazy('health/HealthInterfere')
        },
        {
          path: '/home/health-interfere-detail/:id/:type/:payment',
          name: 'health-interfere-detail',
          meta: {
            name: '健康干预详情'
          },
          component: lazy('health/HealthInterfereDetail')
        },
        {
          path: '/home/health-monitor',
          name: 'health-monitor',
          meta: {
            name: '健康监测'
          },
          component: lazy('health-track/HealthMonitor')
        },
        {
          path: '/home/monitor/:type/:monitorId/:gender',
          name: 'monitorDetail',
          meta: {
            name: '健康监测详情'
          },
          component: lazy('health-track/HealthMonitorDetail')
        },
        {
          path: '/home/client-center',
          name: 'client-center',
          meta: {
            name: '用户中心'
          },
          component: lazy('health/ClientCenter')
        },
        {
          path: '/home/title-manage',
          name: 'title-manage',
          meta: {
            name: '职务管理'
          },
          component: lazy('system-config/TitleManage')
        },
        {
          path: '/home/add-title',
          name: 'add-title',
          meta: {
            name: '添加职务'
          },
          component: lazy('system-config/TitleAdd')
        },
        {
          path: '/home/edit-title',
          name: 'edit-title',
          meta: {
            name: '编辑职务'
          },
          component: lazy('system-config/TitleEdit')
        },
        {
          path: '/home/staff-info',
          name: 'staff-info',
          meta: {
            name: '员工信息'
          },
          component: lazy('system-config/StaffInfo')
        },
        {
          path: '/home/add-staff',
          name: 'add-staff',
          meta: {
            name: '添加员工'
          },
          component: lazy('system-config/StaffAdd')
        },
        {
          path: '/home/staff-edit',
          name: 'staff-edit',
          meta: {
            name: '编辑员工'
          },
          component: lazy('system-config/StaffEdit')
        },
        {
          path: '/home/admin',
          name: 'admin',
          meta: {
            name: '管理员管理'
          },
          component: lazy('system-config/Admin')
        },
        {
          path: '/home/reference',
          name: 'reference',
          meta: {
            name: '健康指标库'
          },
          component: lazy('system-config/ReferencedBank')
        },
        {
          path: '/home/food-manage',
          name: 'food',
          meta: {
            name: '食材管理'
          },
          component: lazy('system-config/FoodManage')
        },
        {
          path: '/home/add-food',
          name: 'add-food',
          meta: {
            name: '添加食品'
          },
          component: lazy('system-config/FoodAdd')
        },
        {
          path: '/home/recipes',
          name: 'recipes',
          meta: {
            name: '食谱管理'
          },
          component: lazy('system-config/Recipes')
        },
        {
          path: '/home/add-recipes',
          name: 'add-recipes',
          meta: {
            name: '添加食谱'
          },
          component: lazy('system-config/RecipesAdd')
        },
        {
          path: '/home/exercise',
          name: 'exercise',
          meta: {
            name: '运动信息管理'
          },
          component: lazy('system-config/Exercise')
        },
        {
          path: '/home/exercise-info',
          name: 'exercise-info',
          meta: {
            name: '添加运动'
          },
          component: lazy('system-config/ExerciseInfo')
        },
        {
          path: '/home/message',
          name: 'message',
          meta: {
            name: '消息管理'
          },
          component: lazy('system-config/Message')
        },
        {
          path: '/home/exercise-tarck',
          name: 'exercise-tarck',
          meta: {
            name: '运动跟踪'
          },
          component: lazy('health-track/ExerciseTrack')
        },
        {
          path: '/home/diet-tarck',
          name: 'diet-tarck',
          meta: {
            name: '膳食跟踪'
          },
          component: lazy('health-track/DietTrack')
        },
        {
          path: '/home/department',
          name: 'department',
          meta: {
            name: '科室管理'
          },
          component: lazy('doctor/Department')
        },
        {
          path: '/home/doctor',
          name: 'doctor',
          meta: {
            name: '医生信息'
          },
          component: lazy('doctor/index')
        }
      ]
    },
    {
      path: '*',
      redirect: '/login'
    }
  ]
})



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/router/index.ts